/** Store rentals: armor skins (and items with an `expiresAt`) are owned until their time ends. */

/** The skins still running: id to the end of its time (ms since epoch). */
export function activeSkins(skinUntil: Record<string, number>, now = Date.now()): string[] {
  return Object.entries(skinUntil)
    .filter(([, until]) => until > now)
    .map(([id]) => id);
}

/** Whole days left before `until`, rounded up (0 when over). */
export function daysLeft(until: number, now = Date.now()): number {
  return until > now ? Math.ceil((until - now) / 86_400_000) : 0;
}
